import React from 'react';
import {
    Flex,
    DialogTitle,
    Dialog,
    PriorityIcon,
    Button
} from '@priority-software/priority-style-react';
import texts from '../../texts';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onApprove: () => void;
    onDecline: () => void;
};

export const SkipOnboardingDialog = (props: Props) => {
    const {isOpen, onClose, onApprove, onDecline} = props;

    return (
        <Dialog
            zIndex={4000}
            isOpen={isOpen}
            onClose={onClose}
            width={480}
            title={
                <DialogTitle
                    icon={PriorityIcon.questionCircle}
                    skin="text"
                    textColor="secondary-400"
                    title={texts.skip_warning}
                />
            }
            footer={
                <Flex>
                    <Button skin="primary" size="large" onClick={onApprove}>
                        {texts.skip_btn_label_yes}
                    </Button>
                    <Button skin="secondary" size="large" onClick={onDecline}>
                        {texts.skip_btn_label_no}
                    </Button>
                </Flex>
            }
        />
    );
};
